import classNames from 'classnames';
import { useIsInProduction } from 'contexts/environment/useIsProduction';
import { useToggle } from 'hooks/useToggle';
import { FC } from 'react';
import { useIntl } from 'react-intl';

export const ResetButton: FC<{ onReset: () => void; className?: string }> = ({ onReset, className }) => {
  const { formatMessage } = useIntl();
  return (
    <button type="button" className={classNames('btn btn-danger', className)} onClick={onReset}>
      {formatMessage({ id: 'errorTryAgain' })}
    </button>
  );
};

export const TechnicalDetails: FC<{
  stack?: string;
  errorMessage?: string;
  reset: () => void;
  className?: string;
}> = ({ errorMessage, reset, className, stack }) => {
  const isInProduction = useIsInProduction();
  const { formatMessage } = useIntl();
  const { isOn, toggleOn } = useToggle();
  if (isInProduction) {
    return null;
  }
  return (
    <>
      {!isOn && (
        <a className="d-block mt-2 text-link fs-6" onClick={toggleOn}>
          {formatMessage({ id: 'errorTechnicalDetails' })}
        </a>
      )}
      {isOn && (
        <div className={classNames('d-flex align-items-stretch mt-2', className)}>
          <div className="flex-grow-1">
            <pre className="fs-6 text-danger text-wrap">{errorMessage}</pre>
            <code className="fs-6 text-danger text-wrap">{stack}</code>
          </div>
          <div className="flex-shrink-0 d-flex flex-column justify-content-center">
            <ResetButton className="ms-3" onReset={reset} />
          </div>
        </div>
      )}
    </>
  );
};
